import React from 'react';
import { Link } from 'react-router-dom';

const Forum: React.FC = () => {
    return (
        <>
            {/* page title */}
            <div className="container py-3">
                <div className="row align-items-center page-title">
                    <div className="col col-sm mb-3 mb-sm-0">
                        <h6 className="mb-0">Forum</h6>
                        <p className="text-secondary small">Lets make it open environment to get helped</p>
                    </div>
                    <div className="col-auto ps-0 position-relative mb-3 mb-sm-0">
                        <button className="btn btn-link btn-square" type="button" data-bs-toggle="offcanvas" data-bs-target="#filter" aria-expanded="false">
                            <i className="bi bi-funnel"></i>
                        </button>
                    </div>
                </div>
                <nav aria-label="breadcrumb" className="breadcrumb-theme bg-theme-1-subtle px-2 py-1 mt-0 mt-sm-3 rounded">
                    <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item bi"><Link to="/app/dashboard"><i className="bi bi-house-door me-2"></i> DevUIUX</Link></li>
                        <li className="breadcrumb-item bi active" aria-current="page"> Forum</li>
                    </ol>
                </nav>
            </div>

            {/* content */}
            <div className="container" id="main-content">
                <div className="py-4 py-lg-5 px-3 position-relative text-center rounded overflow-hidden mb-3 mb-lg-4 z-index-0 bg-theme-r-gradient">
                    <figure className="coverimg h-100 w-100 z-index-0 position-absolute top-0 start-0 m-0 opacity-25">
                        <img src={asset("assets/img/background-image/backgorund-image-2.jpg")} alt="" />
                    </figure>
                    <div className="card-body position-relative z-index-1">
                        <div className="row py-3 py-xl-4 align-items-center justify-content-center">
                            <div className="col-12 col-md-10 col-lg-10 col-xl-9 col-xxl-8 text-center">
                                <h1 className="mb-3">The Place to find<br /> The best answers of your questions.</h1>
                                <p className="opacity-75 small mb-3 mb-md-4">Ask questions, Build network, Connect with same tastes people, share your ideas and help other people by helping, votes and give advices.</p>
                                <button className="btn btn-accent">Community <i className="bi bi-chevron-right"></i></button>
                                <button className="btn btn-light ms-2">Watch Demo <i className="bi bi-camera-reels"></i></button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* search */}
                <div className="row gx-3 gx-lg-4 align-items-center justify-content-center mb-3 mb-lg-4">
                    <div className="col-12 col-md mb-3 mb-md-0">
                        <div className="input-group rounded">
                            <span className="input-group-text text-theme-1"><i className="bi bi-search"></i></span>
                            <input className="form-control" type="search" placeholder="Search your query here..." />
                        </div>
                    </div>
                    <div className="col-6 col-md-auto d-grid">
                        <button className="btn btn-theme">Ask Query</button>
                    </div>
                    <div className="col-6 col-md-auto d-grid">
                        <button className="btn btn-theme">Write Post</button>
                    </div>
                </div>

                {/* summary of community */}
                <div className="row gx-3">
                    <div className="col-12 col-md-12 col-lg-6 col-xl-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto">
                                        <div className="avatar avatar-50 rounded-circle bg-theme-1 theme-purple shadow-sm text-white">
                                            <i className="bi bi-people h5"></i>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <h5 className="mb-1">100+ million</h5>
                                        <p className="small text-secondary">Monthly visitors & Words Exchanged</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-12 col-lg-6 col-xl-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto">
                                        <div className="avatar avatar-50 rounded-circle bg-theme-1 theme-orange shadow-sm text-white">
                                            <i className="bi bi-life-preserver h5"></i>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <h5 className="mb-1">45.1+ billion</h5>
                                        <p className="small text-secondary">People get helps and queries solved</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-12 col-lg-6 col-xl-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto">
                                        <div className="avatar avatar-50 rounded-circle bg-theme-1 theme-green shadow-sm text-white">
                                            <i className="bi bi-patch-check h5"></i>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <h5 className="mb-1">101% ROI</h5>
                                        <p className="small text-secondary">Customer used our premium product features</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-12 col-lg-6 col-xl-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto">
                                        <div className="avatar avatar-50 rounded-circle bg-theme-1 shadow-sm text-white">
                                            <i className="bi bi-globe h5"></i>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <h5 className="mb-1">1000</h5>
                                        <p className="small text-secondary">Average new web application build per month.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Filter */}
                <div className="row gx-3 gx-lg-4 align-items-center">
                    <div className="col mb-3 mb-lg-4">
                        <h6>225 questions</h6>
                    </div>
                    <div className="col-auto mb-3 mb-lg-4">
                        <span className="me-2">Sort by:</span>
                        <div className="btn-group btn-group-sm" role="group" aria-label="Filter toggle">
                            <input type="radio" name="filterbox" className="btn-check" id="btncheck1filter" checked />
                            <label className="btn btn-outline-theme" htmlFor="btncheck1filter">Newest</label>

                            <input type="radio" name="filterbox" className="btn-check" id="btncheck2filter" />
                            <label className="btn btn-outline-theme" htmlFor="btncheck2filter">Active</label>

                            <input type="radio" name="filterbox" className="btn-check" id="btncheck3filter" />
                            <label className="btn btn-outline-theme" htmlFor="btncheck3filter">Unanswered</label>

                            <input type="radio" name="filterbox" className="btn-check" id="btncheck4filter" />
                            <label className="btn btn-outline-theme" htmlFor="btncheck4filter">Top Rated</label>
                        </div>
                    </div>
                </div>

                {/* questions and answer*/}
                <div className="row gx-3 gx-lg-4">
                    <div className="col-12 col-md-8 col-lg-9 col-xl-9">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3 align-items-center mb-3">
                                    <div className="col">
                                        <h6><Link to="/app/forum-details" className="style-none">How to create admin dashboard for Finance Application?</Link></h6>
                                    </div>
                                    <div className="col-auto">
                                        <div className="dropdown">
                                            <button className="btn btn-square btn-link dropdown-toggle no-caret" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                <i className="bi bi-three-dots-vertical vm"></i>
                                            </button>
                                            <ul className="dropdown-menu dropdown-menu-end ">
                                                <li><a className="dropdown-item">Hide from Timeline</a></li>
                                                <li><a className="dropdown-item">Report</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="row gx-3 align-items-center mb-3">
                                    <div className="col-auto">
                                        <figure className="avatar avatar-40 rounded-circle coverimg vm">
                                            <img src={asset("assets/img/adminuiux/user-4.jpg")} alt="" />
                                        </figure>
                                    </div>
                                    <div className="col">
                                        <p className="small text-secondary mb-0">Asked by</p>
                                        <p className="mb-0">David Warner <small className="text-secondary">1 hr ago</small></p>
                                    </div>
                                </div>
                                <p className="text-secondary small">You can easily find template for UI with best customize facility named "DevUIUX". DevUIUX just because every home with windows needs door. everWhen you get older many people will listen you carefully, no matter if its correct discussion or not.</p>
                                <p>
                                    <span className="badge badge-lg badge-light text-bg-theme-1 theme-red me-1 mt-1">Support</span>
                                    <span className="badge badge-lg badge-light text-bg-theme-1 theme-red me-1 mt-1">Development</span>
                                </p>
                            </div>
                            <div className="card-footer">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto mb-3 mb-md-0">
                                        <div className="btn btn-outline-theme theme-red btn-square rounded-circle">
                                            <i className="bi bi-heart"></i>
                                        </div>
                                    </div>
                                    <div className="col-auto mb-3 mb-md-0">
                                        <p className="text-secondary small mb-0">Liked by</p>
                                        <h6>1.2k</h6>
                                    </div>
                                    <div className="col-auto mb-3 mb-md-0">
                                        <div className="avatar avatar-30 coverimg rounded-circle me-1">
                                            <img src={asset("assets/img/adminuiux/user-2.jpg")} alt="" />
                                        </div>
                                        <div className="avatar avatar-30 coverimg rounded-circle me-1">
                                            <img src={asset("assets/img/adminuiux/user-3.jpg")} alt="" />
                                        </div>
                                        <div className="avatar avatar-30 coverimg rounded-circle me-1">
                                            <img src={asset("assets/img/adminuiux/user-4.jpg")} alt="" />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <p className="text-secondary small mb-0">Answers</p>
                                        <h6>9+</h6>
                                    </div>
                                    <div className="col-auto text-center">
                                        <p className="small text-secondary mb-0">Views</p>
                                        <h6>152</h6>
                                    </div>
                                    <div className="col-auto text-center">
                                        <p className="small text-secondary mb-0">Watching</p>
                                        <h6>256</h6>
                                    </div>
                                    <div className="col-auto">
                                        <a className="btn btn-theme">Answer</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3 align-items-center mb-3">
                                    <div className="col">
                                        <h6><Link to="/app/forum-details" className="style-none">Couldn't access my whatsapp on my laptop. Can anyone help me?</Link></h6>
                                    </div>
                                    <div className="col-auto">
                                        <div className="dropdown">
                                            <button className="btn btn-square btn-link dropdown-toggle no-caret" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                <i className="bi bi-three-dots-vertical vm"></i>
                                            </button>
                                            <ul className="dropdown-menu dropdown-menu-end ">
                                                <li><a className="dropdown-item">Hide from Timeline</a></li>
                                                <li><a className="dropdown-item">Report</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="row gx-3 align-items-center mb-3">
                                    <div className="col-auto">
                                        <figure className="avatar avatar-40 rounded-circle coverimg vm">
                                            <img src={asset("assets/img/adminuiux/user-4.jpg")} alt="" />
                                        </figure>
                                    </div>
                                    <div className="col">
                                        <p className="small text-secondary mb-0">Asked by</p>
                                        <p className="mb-0">David Warner <small className="text-secondary">1 hr ago</small></p>
                                    </div>
                                </div>
                                <p className="text-secondary small">You can easily find template for UI with best customize facility named "DevUIUX". DevUIUX just because every home with windows needs door. everWhen you get older many people will listen you carefully, no matter if its correct discussion or not.</p>
                                <p>
                                    <span className="badge badge-light badge-lg text-bg-theme-1 theme-purple me-1 mb-1">Computer</span>
                                    <span className="badge badge-light badge-lg text-bg-theme-1 theme-yellow me-1 mb-1">General</span>
                                </p>
                            </div>
                            <div className="card-footer">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto mb-3 mb-md-0">
                                        <div className="btn btn-outline-theme theme-red btn-square rounded-circle">
                                            <i className="bi bi-heart"></i>
                                        </div>
                                    </div>
                                    <div className="col-auto mb-3 mb-md-0">
                                        <p className="text-secondary small mb-0">Liked by</p>
                                        <h6>1.2k</h6>
                                    </div>
                                    <div className="col-auto mb-3 mb-md-0">
                                        <div className="avatar avatar-30 coverimg rounded-circle me-1">
                                            <img src={asset("assets/img/adminuiux/user-2.jpg")} alt="" />
                                        </div>
                                        <div className="avatar avatar-30 coverimg rounded-circle me-1">
                                            <img src={asset("assets/img/adminuiux/user-3.jpg")} alt="" />
                                        </div>
                                        <div className="avatar avatar-30 coverimg rounded-circle me-1">
                                            <img src={asset("assets/img/adminuiux/user-4.jpg")} alt="" />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <p className="text-secondary small mb-0">Answers</p>
                                        <h6>9+</h6>
                                    </div>
                                    <div className="col-auto text-center">
                                        <p className="small text-secondary mb-0">Views</p>
                                        <h6>152</h6>
                                    </div>
                                    <div className="col-auto text-center">
                                        <p className="small text-secondary mb-0">Watching</p>
                                        <h6>256</h6>
                                    </div>
                                    <div className="col-auto">
                                        <a className="btn btn-theme">Answer</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3 align-items-center mb-3">
                                    <div className="col">
                                        <h6><Link to="/app/forum-details" className="style-none">Bamboo tree growing indoor tips and tricks.</Link></h6>
                                    </div>
                                    <div className="col-auto">
                                        <div className="dropdown">
                                            <button className="btn btn-square btn-link dropdown-toggle no-caret" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                <i className="bi bi-three-dots-vertical vm"></i>
                                            </button>
                                            <ul className="dropdown-menu dropdown-menu-end ">
                                                <li><a className="dropdown-item">Hide from Timeline</a></li>
                                                <li><a className="dropdown-item">Report</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="row gx-3 align-items-center mb-3">
                                    <div className="col-auto">
                                        <figure className="avatar avatar-40 rounded-circle coverimg vm">
                                            <img src={asset("assets/img/adminuiux/user-1.jpg")} alt="" />
                                        </figure>
                                    </div>
                                    <div className="col">
                                        <p className="small text-secondary mb-0">Asked by</p>
                                        <p className="mb-0">Junior Natu <small className="text-secondary">2 hr ago</small></p>
                                    </div>
                                </div>
                                <p className="text-secondary small">You can easily find template for UI with best customize facility named "DevUIUX". DevUIUX just because every home with windows needs door. everWhen you get older many people will listen you carefully, no matter if its correct discussion or not.</p>
                                <p>
                                    <span className="badge badge-lg badge-light text-bg-theme-1 theme-teal me-1 mt-1">Nature</span>
                                    <span className="badge badge-lg badge-light text-bg-theme-1 theme-cyan me-1 mt-1">Environment</span>
                                </p>
                            </div>
                            <div className="card-footer">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto mb-3 mb-md-0">
                                        <div className="btn btn-outline-theme theme-red btn-square rounded-circle">
                                            <i className="bi bi-heart"></i>
                                        </div>
                                    </div>
                                    <div className="col-auto mb-3 mb-md-0">
                                        <p className="text-secondary small mb-0">Liked by</p>
                                        <h6>1.2k</h6>
                                    </div>
                                    <div className="col-auto mb-3 mb-md-0">
                                        <div className="avatar avatar-30 coverimg rounded-circle me-1">
                                            <img src={asset("assets/img/adminuiux/user-2.jpg")} alt="" />
                                        </div>
                                        <div className="avatar avatar-30 coverimg rounded-circle me-1">
                                            <img src={asset("assets/img/adminuiux/user-3.jpg")} alt="" />
                                        </div>
                                        <div className="avatar avatar-30 coverimg rounded-circle me-1">
                                            <img src={asset("assets/img/adminuiux/user-4.jpg")} alt="" />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <p className="text-secondary small mb-0">Answers</p>
                                        <h6>9+</h6>
                                    </div>
                                    <div className="col-auto text-center">
                                        <p className="small text-secondary mb-0">Views</p>
                                        <h6>152</h6>
                                    </div>
                                    <div className="col-auto text-center">
                                        <p className="small text-secondary mb-0">Watching</p>
                                        <h6>256</h6>
                                    </div>
                                    <div className="col-auto">
                                        <a className="btn btn-theme">Answer</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3 align-items-center mb-3">
                                    <div className="col">
                                        <h6><Link to="/app/forum-details" className="style-none">Raja Ravi Varma is not king and don't have any kingdom. Why he called Raja(King)?</Link></h6>
                                    </div>
                                    <div className="col-auto">
                                        <div className="dropdown">
                                            <button className="btn btn-square btn-link dropdown-toggle no-caret" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                <i className="bi bi-three-dots-vertical vm"></i>
                                            </button>
                                            <ul className="dropdown-menu dropdown-menu-end ">
                                                <li><a className="dropdown-item">Hide from Timeline</a></li>
                                                <li><a className="dropdown-item">Report</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="row gx-3 align-items-center mb-3">
                                    <div className="col-auto">
                                        <figure className="avatar avatar-40 rounded-circle coverimg vm">
                                            <img src={asset("assets/img/adminuiux/user-2.jpg")} alt="" />
                                        </figure>
                                    </div>
                                    <div className="col">
                                        <p className="small text-secondary mb-0">Asked by</p>
                                        <p className="mb-0">Madhuvani <small className="text-secondary">10 hr ago</small></p>
                                    </div>
                                </div>
                                <p className="text-secondary small">You can easily find template for UI with best customize facility named "DevUIUX". DevUIUX just because every home with windows needs door. everWhen you get older many people will listen you carefully, no matter if its correct discussion or not.</p>
                                <p>
                                    <span className="badge badge-lg badge-light text-bg-theme-1 theme-pink me-1 mt-1">Art</span>
                                    <span className="badge badge-lg badge-light text-bg-theme-1 theme-orange me-1 mt-1">History</span>
                                </p>
                            </div>
                            <div className="card-footer">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto mb-3 mb-md-0">
                                        <div className="btn btn-outline-theme theme-red btn-square rounded-circle">
                                            <i className="bi bi-heart"></i>
                                        </div>
                                    </div>
                                    <div className="col-auto mb-3 mb-md-0">
                                        <p className="text-secondary small mb-0">Liked by</p>
                                        <h6>1.2k</h6>
                                    </div>
                                    <div className="col-auto mb-3 mb-md-0">
                                        <div className="avatar avatar-30 coverimg rounded-circle me-1">
                                            <img src={asset("assets/img/adminuiux/user-2.jpg")} alt="" />
                                        </div>
                                        <div className="avatar avatar-30 coverimg rounded-circle me-1">
                                            <img src={asset("assets/img/adminuiux/user-3.jpg")} alt="" />
                                        </div>
                                        <div className="avatar avatar-30 coverimg rounded-circle me-1">
                                            <img src={asset("assets/img/adminuiux/user-4.jpg")} alt="" />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <p className="text-secondary small mb-0">Answers</p>
                                        <h6>9+</h6>
                                    </div>
                                    <div className="col-auto text-center">
                                        <p className="small text-secondary mb-0">Views</p>
                                        <h6>152</h6>
                                    </div>
                                    <div className="col-auto text-center">
                                        <p className="small text-secondary mb-0">Watching</p>
                                        <h6>256</h6>
                                    </div>
                                    <div className="col-auto">
                                        <a className="btn btn-theme">Answer</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3 align-items-center mb-3">
                                    <div className="col">
                                        <h6><Link to="/app/forum-details" className="style-none">Which the best template for Admin and Dashboard Application?</Link></h6>
                                    </div>
                                    <div className="col-auto">
                                        <div className="dropdown">
                                            <button className="btn btn-square btn-link dropdown-toggle no-caret" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                <i className="bi bi-three-dots-vertical vm"></i>
                                            </button>
                                            <ul className="dropdown-menu dropdown-menu-end ">
                                                <li><a className="dropdown-item">Hide from Timeline</a></li>
                                                <li><a className="dropdown-item">Report</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="row gx-3 align-items-center mb-3">
                                    <div className="col-auto">
                                        <figure className="avatar avatar-40 rounded-circle coverimg vm">
                                            <img src={asset("assets/img/adminuiux/user-4.jpg")} alt="" />
                                        </figure>
                                    </div>
                                    <div className="col">
                                        <p className="small text-secondary mb-0">Asked by</p>
                                        <p className="mb-0">David Warner <small className="text-secondary">1 hr ago</small></p>
                                    </div>
                                </div>
                                <p className="text-secondary small">You can easily find template for UI with best customize facility named "DevUIUX". DevUIUX just because every home with windows needs door. everWhen you get older many people will listen you carefully, no matter if its correct discussion or not.</p>
                                <p>
                                    <span className="badge badge-lg badge-light text-bg-theme-1 theme-red me-1 mt-1">Support</span>
                                    <span className="badge badge-lg badge-light text-bg-theme-1 theme-red me-1 mt-1">Development</span>
                                </p>
                            </div>
                            <div className="card-footer">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto mb-3 mb-md-0">
                                        <div className="btn btn-outline-theme theme-red btn-square rounded-circle">
                                            <i className="bi bi-heart"></i>
                                        </div>
                                    </div>
                                    <div className="col-auto mb-3 mb-md-0">
                                        <p className="text-secondary small mb-0">Liked by</p>
                                        <h6>1.2k</h6>
                                    </div>
                                    <div className="col-auto mb-3 mb-md-0">
                                        <div className="avatar avatar-30 coverimg rounded-circle me-1">
                                            <img src={asset("assets/img/adminuiux/user-2.jpg")} alt="" />
                                        </div>
                                        <div className="avatar avatar-30 coverimg rounded-circle me-1">
                                            <img src={asset("assets/img/adminuiux/user-3.jpg")} alt="" />
                                        </div>
                                        <div className="avatar avatar-30 coverimg rounded-circle me-1">
                                            <img src={asset("assets/img/adminuiux/user-4.jpg")} alt="" />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <p className="text-secondary small mb-0">Answers</p>
                                        <h6>9+</h6>
                                    </div>
                                    <div className="col-auto text-center">
                                        <p className="small text-secondary mb-0">Views</p>
                                        <h6>152</h6>
                                    </div>
                                    <div className="col-auto text-center">
                                        <p className="small text-secondary mb-0">Watching</p>
                                        <h6>256</h6>
                                    </div>
                                    <div className="col-auto">
                                        <a className="btn btn-theme">Answer</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-4 col-lg-3 col-xl-3">
                        <div className="card bg-l-gradient-light mb-3 mb-lg-4">
                            <div className="card-header border-bottom">
                                <h6>Featured Questions</h6>
                            </div>
                            <div className="card-body p-0">
                                <div className="list-group list-group-flush bg-none">
                                    <Link to="/app/forum-details" className="list-group-item list-group-item-action">How to become most powerful development partner?</Link>
                                    <Link to="/app/forum-details" className="list-group-item list-group-item-action">The best way to get started with the getDevUIUX</Link>
                                    <Link to="/app/forum-details" className="list-group-item list-group-item-action">I have found egyptian assets, What I should do with it?</Link>
                                    <Link to="/app/forum-details" className="list-group-item list-group-item-action">How long it will take to make world record for traveling?</Link>
                                    <Link to="/app/forum-details" className="list-group-item list-group-item-action ">I am disabled person by my hands. What is my career options?</Link>
                                </div>
                            </div>
                        </div>
                        {/* advertisement */}
                        <p className="text-secondary text-center small">Advertisement</p>
                        <div className="card mb-3 mb-lg-4 overflow-hidden">
                            <div className="row gx-0">
                                <div className="col-6 bg-theme-1 text-white text-center p-3 z-index-1">
                                    <div className="position-relative">
                                        <h4 className="mb-2">15% OFF</h4>
                                        <p className="opacity-75 small mb-3">Price including with our launch offer get 5% Extra</p>
                                        <button className="copy-text btn btn-sm btn-rounded btn-outline-dashed text-white border-white">GOREELLAUNCH</button>
                                    </div>
                                </div>
                                <div className="col-6 position-relative">
                                    <figure className="coverimg position-absolute w-100 h-100 start-0 top-0 m-0">
                                        <img src={asset("../../assets/img/adminuiux/image-1.jpg")} className="mw-100" alt="" />
                                    </figure>
                                </div>
                            </div>
                        </div>
                        <h6 className="mb-3 mb-lg-4">Trending Tags</h6>
                        <div>
                            <a className="badge badge-lg badge-light text-bg-theme-1 me-1 my-1">Android</a>
                            <a className="badge badge-lg badge-light text-bg-theme-1 me-1 my-1">iOS</a>
                            <a className="badge badge-lg badge-light text-bg-theme-1 me-1 my-1">Windows11</a>
                            <a className="badge badge-lg badge-light text-bg-theme-1 me-1 my-1">Fluent ui</a>
                            <a className="badge badge-lg badge-light text-bg-theme-1 me-1 my-1">Win UI</a>
                            <a className="badge badge-lg badge-light text-bg-theme-1 me-1 my-1">Template</a>
                            <a className="badge badge-lg badge-light text-bg-theme-1 me-1 my-1">Dashboard</a>
                            <a className="badge badge-lg badge-light text-bg-theme-1 me-1 my-1">Bootstrap</a>
                            <a className="badge badge-lg badge-light text-bg-theme-1 me-1 my-1">Angular admin</a>
                            <a className="badge badge-lg badge-light text-bg-theme-1 me-1 my-1">Free Dashboard</a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Forum;
